import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-airport-list',
  templateUrl: './skeleton-airport-list.component.html',
  styleUrls: ['./skeleton-airport-list.component.scss'],
})
export class SkeletonAirportListComponent {
  @Input() count = 5;
}
